/* ============================================================
   /search — relevancia-primero (Sneaker Lane).

   PROBLEMA que resuelve (Jorge 2026-07-15): la búsqueda nativa de Shopify
   devuelve muchos resultados por relevancia difusa (cualquier producto con
   "jordan" o "4" en título/etiquetas/descripción), y el enfoque anterior
   ESCONDÍA el ruido en cliente. Con la paginación nativa, cada "Cargar más"
   traía 24 en bruto de los que casi todos quedaban ocultos → parecía roto y
   nunca se veían "todas las Jordan 4".

   AHORA:
   1. Al buscar, se cargan TODAS las páginas por detrás (fetch en paralelo) para
      tener el conjunto completo en el DOM.
   2. Se PARTE en dos bloques, sin esconder nada:
        · Arriba: TODAS las coincidencias exactas (el título contiene cada
          palabra de la búsqueda; los números — "4", "11", "550" — como token
          exacto para no colar 14/44/450).
        · Debajo, tras "También te puede interesar": el resto (recomendaciones).
   3. Los agotados salen igual (con su badge "Sold out"); el orden dentro de
      cada bloque respeta la relevancia de Shopify.

   Degradación elegante: si el JS falla, queda el grid nativo + el botón
   "Cargar más" (link normal) que ya renderiza el Liquid.
   ============================================================ */
(function () {
  if (window.__slSearchInit) return;
  window.__slSearchInit = true;

  var PAGE_SIZE = 24; // DEBE coincidir con {% paginate search.results by N %}
  var MAX_PAGES = 40; // tope de seguridad (960 resultados)

  // --- Helpers de texto (espejo del predictive search) ---
  function normalize(str) {
    return (str || "").toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, "");
  }
  function tokenize(text) {
    return normalize(text).split(/[\s\-_/.,()\[\]&|:;!?"'`+]+/).filter(Boolean);
  }
  var NUMERIC_RE = /^\d+$/;
  function termMatchesTokens(tokens, term) {
    // Número → token EXACTO ("4" casa "jordan 4" pero no "14"/"44"/"450").
    if (NUMERIC_RE.test(term)) return tokens.indexOf(term) !== -1;
    // Palabra → prefijo (casa "jordan"→"jordans", "retro"→"retro").
    for (var i = 0; i < tokens.length; i++) {
      if (tokens[i].indexOf(term) === 0) return true;
    }
    return false;
  }
  function getQueryTerms() {
    var params = new URLSearchParams(window.location.search);
    var q = (params.get("q") || "").trim();
    if (!q) return { raw: "", terms: [] };
    return { raw: q, terms: normalize(q).split(/\s+/).filter(Boolean) };
  }
  function escapeHtml(str) {
    return String(str).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  // --- Cabecera dinámica "Resultados para X · N" ---
  function injectHeading() {
    var existing = document.querySelector(".sl-search-dynamic-heading");
    if (existing) return existing;
    var anchor = document.querySelector(".template-search__search");
    if (!anchor) return null;
    var h = document.createElement("p");
    h.className = "sl-search-dynamic-heading";
    anchor.insertAdjacentElement("afterend", h);
    return h;
  }
  function updateHeading(exactCount, recCount) {
    var q = getQueryTerms();
    var heading = injectHeading();
    if (!heading) return;
    if (!q.raw) {
      heading.style.display = "none";
      return;
    }
    heading.style.display = "";
    if (!exactCount) {
      heading.innerHTML = 'Sin coincidencias exactas para "' + escapeHtml(q.raw) + '"' +
        (recCount ? '<span class="sl-search-dynamic-heading__count"> · ' + recCount + " recomendacion" + (recCount === 1 ? "" : "es") + "</span>" : "");
      return;
    }
    heading.innerHTML =
      'Resultados para "' + escapeHtml(q.raw) + '"' +
      '<span class="sl-search-dynamic-heading__count"> · ' + exactCount + " resultado" + (exactCount === 1 ? "" : "s") + "</span>";
  }

  function getGrid() {
    return document.querySelector(".template-search .product-grid");
  }
  function getTotalResults() {
    var root = document.querySelector("[data-sl-search-total]");
    if (!root) return null;
    var n = parseInt(root.getAttribute("data-sl-search-total"), 10);
    return isFinite(n) ? n : null;
  }

  // --- 1) Cargar TODAS las páginas restantes (en paralelo) ---
  var loading = false;
  function setLoading(on) {
    var container = document.getElementById("ProductGridContainer");
    if (!container) return;
    container.classList.toggle("sl-search-loading-all", on);
    var note = document.querySelector(".sl-search-loading-note");
    if (on && !note) {
      note = document.createElement("p");
      note.className = "sl-search-loading-note";
      note.textContent = "Cargando todos los resultados…";
      var grid = getGrid();
      if (grid) grid.insertAdjacentElement("afterend", note);
    } else if (!on && note) {
      note.remove();
    }
  }

  function loadAllPages() {
    // Solo tiene sentido cargarlo todo si hay una búsqueda activa (si no, es
    // /search vacío o navegación general → no barremos todo el catálogo).
    if (getQueryTerms().terms.length === 0) return Promise.resolve();
    var total = getTotalResults();
    var grid = getGrid();
    if (!grid || !total || total <= PAGE_SIZE) return Promise.resolve();
    var pages = Math.min(Math.ceil(total / PAGE_SIZE), MAX_PAGES);
    var base = window.location.href;
    var urls = [];
    for (var p = 2; p <= pages; p++) {
      var u = new URL(base);
      u.searchParams.set("page", String(p));
      urls.push({ p: p, url: u.toString() });
    }
    setLoading(true);
    return Promise.all(
      urls.map(function (o) {
        return fetch(o.url, { headers: { Accept: "text/html" } })
          .then(function (r) { return r.text(); })
          .then(function (html) { return { p: o.p, html: html }; })
          .catch(function () { return null; });
      })
    ).then(function (results) {
      // Añadir EN ORDEN de página (relevancia) para no barajar el ranking.
      results
        .filter(Boolean)
        .sort(function (a, b) { return a.p - b.p; })
        .forEach(function (res) {
          var doc = new DOMParser().parseFromString(res.html, "text/html");
          doc.querySelectorAll(".template-search .product-grid > li").forEach(function (li) {
            grid.appendChild(li);
          });
        });
      // Ya está todo cargado → fuera el botón "Cargar más".
      var lm = document.querySelector(".sl-search-load-more-wrapper");
      if (lm) lm.remove();
      setLoading(false);
    });
  }

  // --- 2) Partir en "exactas" (arriba) + "recomendaciones" (abajo) ---
  function ensureRecsSection() {
    var recs = document.querySelector(".sl-search-recs");
    if (recs) return recs;
    var container = document.getElementById("product-grid");
    var mainGrid = getGrid();
    if (!container || !mainGrid) return null;
    recs = document.createElement("div");
    recs.className = "sl-search-recs";
    recs.innerHTML =
      '<div class="sl-search-recs__divider"><h2 class="sl-search-recs__title">También te puede interesar</h2></div>' +
      '<ul class="' + mainGrid.className + ' sl-search-recs__grid" role="list"></ul>';
    container.appendChild(recs);
    return recs;
  }

  function partition() {
    var q = getQueryTerms();
    var grid = getGrid();
    if (!grid) return;

    // Sin términos → no partimos (confiamos en la relevancia de Shopify).
    if (q.terms.length === 0) {
      updateHeading(grid.querySelectorAll(".grid__item").length, 0);
      return;
    }

    var recsSection = ensureRecsSection();
    var recsGrid = recsSection ? recsSection.querySelector(".sl-search-recs__grid") : null;

    // Recolocar TODO al grid principal antes de re-partir (idempotente ante
    // cambios de facetas/orden que re-llaman a partition()).
    if (recsGrid) {
      Array.prototype.slice.call(recsGrid.children).forEach(function (li) { grid.appendChild(li); });
    }

    var items = Array.prototype.slice.call(grid.querySelectorAll(".grid__item[data-product-title]"));
    var exact = 0;
    var rec = 0;
    items.forEach(function (item) {
      var tokens = tokenize(item.getAttribute("data-product-title") || "");
      var isExact = q.terms.every(function (t) { return termMatchesTokens(tokens, t); });
      if (isExact) {
        exact++;
      } else if (recsGrid) {
        recsGrid.appendChild(item); // se mueve al bloque de recomendaciones
        rec++;
      } else {
        exact++;
      }
    });

    if (recsSection) recsSection.style.display = rec > 0 ? "" : "none";
    updateHeading(exact, rec);
  }

  // --- Reaccionar a las facetas/orden (Dawn hace AJAX del grid) ---
  var reinitTimer = null;
  function observeGridChanges() {
    var container = document.getElementById("ProductGridContainer");
    if (!container) return;
    var observer = new MutationObserver(function (mutations) {
      if (loading) return; // ignorar nuestras propias mutaciones
      // Solo reaccionar si Dawn sustituyó el #product-grid entero (cambio de
      // faceta/orden), no cuando movemos li's dentro.
      var swapped = mutations.some(function (m) {
        return Array.prototype.some.call(m.addedNodes, function (n) {
          return n.nodeType === 1 && (n.id === "product-grid" || n.querySelector && n.querySelector("#product-grid, .product-grid"));
        });
      });
      if (!swapped) return;
      clearTimeout(reinitTimer);
      reinitTimer = setTimeout(run, 60);
    });
    observer.observe(container, { childList: true, subtree: true });
  }

  // --- Orquestación ---
  function run() {
    if (loading) return;
    var grid = getGrid();
    if (!grid) {
      updateHeading(0, 0); // estado vacío
      return;
    }
    loading = true;
    loadAllPages()
      .then(function () { partition(); })
      .catch(function () { partition(); })
      .then(function () { loading = false; });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { run(); observeGridChanges(); });
  } else {
    run();
    observeGridChanges();
  }
})();
